import React from 'react'
import { Routes, Route, Outlet } from 'react-router-dom'

// css
import './index.css'
import './chart.css'
import './step.css'

// Layout
import Nav from './layouts/nav'
import Footer from './layouts/Footer'

// Dashboard  
import Home from './components/Dashboard/Home'

// User Management
import UserList from './pages/UserManagement/UserList';
import AddUser from './pages/UserManagement/AddUser';
import EditUser from './pages/UserManagement/EditUser';
import AddExistingUser from './pages/UserManagement/AddExistingUser';

// Staff Management
import StaffList from './pages/StaffManagement/StaffList';
import AddStaff from './pages/StaffManagement/AddStaff';
import EditStaff from './pages/StaffManagement/EditStaff';

// Events Management
import EventsList from './pages/EventsManagement/EventsList';
import EventDetails from './pages/EventsManagement/EventDetails';

// Transaction
import Transaction from './pages/Transaction/index';
import PrimaryMarketTransactions from './pages/Transaction/PrimaryMarket';
import SecondaryMarketTransactions from './pages/Transaction/SecondaryMarket';
import OrganizerTransactions from './pages/Transaction/Organizer';

//Profile
import OrganizerProfile from './pages/OrganizerProfile/OrganizerProfile';
import ChangePassword from './pages/OrganizerProfile/ChangePassword';

// Need to Remove this 

/// Charts
import ChartJs from './components/Dashboard/Chartjs'
import SparklineChart from './components/Dashboard/Sparkline'

//ResaleMarket
import ListedTicket from './pages/ResaleMarket/ListedTicket';
import SoldTicket from './pages/ResaleMarket/SoldTicket';

//OrgTicket
import AddOrgTicket from './pages/OrgTicket/AddOrgTicket';
import ListOrgTicket from './pages/OrgTicket/OrgTicketList';
import EditOrgTicket from './pages/OrgTicket/EditOrgTicket';

import Analytics from './pages/Analytics/Analytics';
import EventAnalytics from './pages/Analytics/EventAnalytics';

const Markup = () => {
  const allroutes = [
    /// Dashboard
    { url: '', component: <Home /> },
    { url: 'dashboard', component: <Home /> },

    /// Chart
    { url: 'chart-sparkline', component: <SparklineChart /> },
    { url: 'chart-chartjs', component: <ChartJs /> },

    // User Management
    { url: 'user-list', component: <UserList /> },
    { url: 'user-add', component: <AddUser /> },
    { url: 'user-edit/:u_id', component: <EditUser /> },
    { url: 'user-add-existing', component: <AddExistingUser /> },

    // Staff Management
    { url: 'staff-list', component: <StaffList /> },
    { url: 'staff-add', component: <AddStaff /> },
    { url: 'staff-edit/:s_id', component: <EditStaff /> },

    // Events Management
    { url: 'events-list', component: <EventsList /> },
    { url: 'event-details/:e_id', component: <EventDetails /> },

    // Transaction
    { url: 'transaction', component: <Transaction /> },
    { url: 'primary-market-transaction', component: <PrimaryMarketTransactions /> },
    { url: 'secondary-market-transaction', component: <SecondaryMarketTransactions /> },
    { url: 'organizers-transaction', component: <OrganizerTransactions /> },


    //Profile
    { url: 'organizer-profile', component: <OrganizerProfile /> },
    { url: 'change-password', component: <ChangePassword /> },

    //Resale Market
    { url: 'listed-tickets', component: <ListedTicket /> },
    { url: 'sold-tickets', component: <SoldTicket /> },

    //OrgTicket
    { url: 'list-org-tickets', component: <ListOrgTicket /> },
    { url: 'add-org-ticket', component: <AddOrgTicket /> },
    { url: 'edit-org-ticket/:t_id', component: <EditOrgTicket /> },

    { url: 'analytics', component: <Analytics /> },
    { url: 'event-analytics/:e_id', component: <EventAnalytics /> },

  ]

  return (
    <>
      <Routes>
        <Route element={<MainLayout />} > 
          {allroutes.map((data, i) => (
            <Route key={i} exact path={`${data.url}`} element={data.component} />
          ))}
        </Route>
      </Routes>
    </>
  )
}

function MainLayout() {
  return (
    <div id="main-wrapper" className="show">
      <Nav />
      <div className="content-body" style={{ minHeight: window.screen.height - 230 }}>
        <div className="container-fluid">
          <Outlet />
        </div>
      </div>
      <Footer />
    </div>
  )
};

export default Markup
